import { OPEN_CLOSE_SEARCH_SCREEN } from "./types";

export const handleSearchScreen = () => (dispatch: any) => {
  dispatch({
    type: OPEN_CLOSE_SEARCH_SCREEN,
  });
};
